<template>
  <div>
    <v-app class="p-4">
      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              max-width="900"
              hide-overlay
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  dark
                  color="primary"
              >
                <v-toolbar-title>ویرایش بسته شماره</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <create-tarefe :key="editModal" :editProps="editProps"></create-tarefe>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->

      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <router-link to="/admin/tarefe/createTarefeList">
            <v-btn class="btn-add-with-text  mt-5">
              <span class="fa fa-plus ml-1"></span>
              ایجاد بسته شماره
            </v-btn>
          </router-link>

          <v-card :loading="loading" class="p-3 pt-0">
            <data-table
                :data="datas"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :per-page="[10, 25, 50, 100, 500]"
                :pagination="paginate"
                :orderBy="tableProps.column"
                :orderDir="tableProps.dir"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search;reloadTable() }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import Swal from "sweetalert2";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "showTarefeList",
  components: {FiltersTable, TitleRibbon, button, dataTableProps, createTarefe},
  props: {
    editProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tarafeName: "",
      editModal: false,
      loading: false,
      datas: {},
      translate: dataTableProps.translate,
      paginate: dataTableProps.pagination,
      tableProps: dataTableProps.tableProps,
      url: `${url}/admin/packs/numbers`,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام',
          name: 'title',
          orderable: true,
          searchable: true,
        },
        {
          label: 'تعداد خط',
          name: 'count',
          transform: (val) => {
            return val.data.count ? val.data.count : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'قیمت',
          name: 'price',
          transform: (val) => {
            return val.data.price ? val.data.price : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'انقضا(روز)',
          name: 'expire',
          transform: (val) => {
            return val.data.is_round ? 'دارد' : 'ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'قابلیت دایورت',
          name: 'data.divert',
          transform: (val) => {
            const color = val.data.data.divert == 'yes' ? 'success' : 'danger';
            const icon = val.data.data.divert == 'yes' ? 'mdi-check' : 'mdi-close';
            return `<i class="mdi ${icon} text-${color}"></i>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'رند',
          name: 'data.rond',
          transform: (val) => {
            const color = val.data.data.rond == 'yes' ? 'success' : 'danger';
            const icon = val.data.data.rond == 'yes' ? 'mdi-check' : 'mdi-close';
            return `<i class="mdi ${icon} text-${color}"></i>`;
          },
          orderable: true,
        },
        {
          label: 'بازگشتی',
          name: 'data.return',
          transform: (val) => {
            const color = val.data.data.return == 'yes' ? 'success' : 'danger';
            const icon = val.data.data.return == 'yes' ? 'mdi-check' : 'mdi-close';
            return `<i class="mdi ${icon} text-${color}"></i>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'رنگ',
          name: 'color',
          transform: (val) => {
            const color = val.data.data.color;
            return `<span class="badge badge-primary mt-2" style="background-color: ${color}">${color}</span>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت',
          name: 'status',
          transform: (val) => {
            let status = () => {
              $.ajax({
                url: `${url}/admin/packs/numbers/${val.data.id}`,
                fn: status,
                type: 'PUT',
                headers: {
                  'Authorization': Token,
                  ACCEPT: 'application/json',
                },
                data: {
                  status: val.data.status == 'active' ? 'inactive' : 'active'
                },
                success: (res) => {
                  this.loading = true;
                  this.reloadTable();
                }
              })
            };

            $(document).on('click', `#${val.data.id}`, status);
            return `<i style="font-size : 18px" class="btn mdi mdi-circle text-${val.data.status == 'active' ? 'success' : 'danger'}" id="${val.data.id}"></i>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'edit',
                label: 'ویرایش',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,
                status: 'admin_number_pack_update',
                condition(status) {
                  return true
                }

              },
              {
                name: 'delete',
                label: 'حذف تعرفه',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
                status: 'admin_number_pack_destroy',
                condition(status) {
                  return true
                }
              },
            ]
          }
        }
      ],
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        fn: this.getDataForTable,
        type: 'GET',
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.datas = data;
          vm.loading = false;
        },
      }).catch(() => {
        vm.loading = false;
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    actions(data, type) {
      const vm = this
      if (type === 'edit') {
        vm.editModal = true;
        vm.editProps = {
          id: data.id,
          title: data.title,
          price: data.price,
          count: data.count,
          expire: data.expire,
          color: data.data.color,
          divert: data.data.divert,
          rond: data.data.rond,
          returned: data.data.return,
          Status: data.status,
        }

      } else if (type === 'delete') {
        this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
          if (value === true) {
            $.ajax({
              url: `${url}/admin/packs/numbers/${data.id}`,
              type: 'DELETE',
              fn: this.actions,
              params: [data, type],
              msg: true,
              headers: {
                'Authorization': Token,
                ACCEPT: 'application/json',
              },
              success: (res) => {
                const message = res.message;
                vm.reloadTable(message);
              }
            })
          }
        }))
      }
    },
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  mounted() {
    this.getDataForTable(this.url);
    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });
  },
}
</script>

<style scoped>

</style>